import React from 'react';
import PropType from 'prop-types';
import styled, { css } from 'styled-components';

const FormFieldWrapper = styled.div`
  position: relative;
  textarea {
    min-height: 150px;
  }
  input[type="color"] {
    padding-left: 56px;
  }
`;

const Label = styled.label``;

Label.Text = styled.span`
  color: #E5E5E5;
  height: 57px;
  position: absolute; 
  top: 0;
  left: 16px;
  
  display: flex;
  align-items: center;
  
  transform-origin: 0% 0%;
  font-size: 18px;
  font-style: normal;
  font-weight: 300;
  
  transition: .1s ease-in-out;
`;

const Input = styled.input`
  background: #53585D;
  color: #F5F5F5;
  display: block;
  width: 100%;
  height: 57px;
  font-size: 18px;
  
  outline: 0;
  border: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid #53585D;
  
  padding: 16px 16px;
  margin-bottom: 45px;
  
  resize: none;
  border-radius: 4px;
  transition: border-color .3s;
  
  &:focus {
    border-bottom-color: var(--primary);
  }
  &:focus:not([type='color']) + ${Label.Text} {
    transform: scale(.6) translateY(-10px);
  }
  ${({ value }) => {
    const hasValue = value.length > 0;
    return hasValue && css`
        &:not([type='color']) + ${Label.Text} {
          transform: scale(.6) translateY(-10px);
        }
      `;
  }
}
`;

function FormField({
  label, name, type, value, onChange, suggestions,
}) {
  const fieldID = `id_${name}`;
  const isTextArea = type === 'textarea';
  const tag = isTextArea ? 'textarea' : 'input';

  const hasSuggestions = Boolean(suggestions.length);
  return (
    <FormFieldWrapper>
      <Label
        htmlFor={fieldID}
      >
        <Input
          as={tag}
          id={fieldID}
          type={type}
          value={value}
          name={name}
          autoComplete={hasSuggestions ? 'off' : 'on'}
          onChange={onChange}
          list={hasSuggestions ? `suggestionFor_${fieldID}` : undefined}
        />
        <Label.Text>
          {label}
          :
        </Label.Text>
        {
          hasSuggestions && (
            <datalist id={`suggestionFor_${fieldID}`}>
              {
              suggestions.map((suggestion) => (
                <option key={`suggestionFor_${fieldID}_option${suggestion}`} value={suggestion}>
                  {suggestion}
                </option>
              ))
            }

            </datalist>
          )
        }

      </Label>

    </FormFieldWrapper>
  );
}

FormField.defaultProps = {
  type: 'text',
  value: '',
  suggestions: [],
};

FormField.propTypes = {
  label: PropType.string.isRequired,
  type: PropType.string,
  name: PropType.string.isRequired,
  value: PropType.string,
  onChange: PropType.func.isRequired,
  suggestions: PropType.arrayOf(PropType.string),
};

export default FormField;
